export default __webpack_public_path__ + "static/media/mockup-step-2.c83f02d7.png";